export const iconFontAwesomeAutomotiveBusSimple = (
	<i className="fa-solid fa-bus-simple"></i>
);
